export default "__VITE_ASSET__BDXFdB6L__"